import { Breadcrumbs, Container, Link, Stack, Typography, colors } from '@mui/material';
import React from 'react';
import PortalHeader from './PortalHeader';
import Cookies from 'universal-cookie';
import { toast } from 'react-hot-toast';
import { fetchWith401Check } from '../../helpers/http';
import RegistrationsTable from './RegistrationsTable';
import DialogLoading from '../../components/DialogLoading';

const Registrations = ({ userInfo }) => {
  const [loadingState, setLoadingState] = React.useState({ fetch: true });
  const [registrations, setRegistrations] = React.useState([]);
  const cookies = new Cookies();

  const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

  const fetchRegistrations = async () => {
    setLoadingState({ ...loadingState, fetch: true });
    fetchWith401Check(`${API_URL}/auth/getregistrations`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        const _registrations = response?.response;
        console.log(_registrations);
        setRegistrations(_registrations);
      })
      .catch(function (err) {
        return toast.error(err.message);
      });

    setLoadingState({ ...loadingState, fetch: false });
  };

  React.useEffect(() => {
    fetchRegistrations();
  }, []);

  const deleteRegistration = (id) => {
    if (!id) return toast.error('ID not found');
    setLoadingState({ ...loadingState, delete: true });
    fetchWith401Check(`${API_URL}/auth/delete-registration/${id}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${cookies.get('token')}` },
      referrer: 'no-referrer',
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);
      })
      .then(function (response) {
        toast.success('Deleted successfully');
        fetchRegistrations();
      })
      .catch(function (err) {
        return toast.error(err.message);
      });
    setLoadingState({ ...loadingState, delete: false });
  };
  return (
    <Stack sx={{ backgroundColor: colors.grey[100] }}>
      <Container sx={{ backgroundColor: colors.grey[50] }}>
        <Stack direction='column' sx={{ minHeight: '100vh' }} p={2} spacing={2}>
          <Stack direction='row' spacing={4} alignItems='center'>
            <Breadcrumbs aria-label='breadcrumb'>
              <Link underline='hover' color='inherit' href='/portal'>
                Home
              </Link>
              <Typography color='text.primary'>Registrations</Typography>
            </Breadcrumbs>
          </Stack>
          <PortalHeader userInfo={userInfo} />
          <Stack>
            <RegistrationsTable registrations={registrations} deleteRegistration={deleteRegistration} />
          </Stack>
        </Stack>
      </Container>
      <DialogLoading props={{ show: loadingState.delete, title: 'Deleting data', description: 'Please wait ...' }} />
    </Stack>
  );
};

export default Registrations;
